import React from 'react';
import {
  BarChartOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  GlobalOutlined,
  LaptopOutlined,
  LinkOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import LabImpact from '../Shared/LabImpact';

const metrics = [
  { value: 39, label: 'Academic Research & Development', icon: ExperimentOutlined },
  { value: 11, label: 'Hardware/ Software', icon: LaptopOutlined },
  { value: 7, label: 'Data & Inventory Management', icon: DatabaseOutlined },
  { value: 21, label: 'Models & Maps Development', icon: GlobalOutlined },
  { value: 37, label: 'Capacity Building', icon: TeamOutlined },
  { value: 16, label: 'Linkages & Commercialization', icon: LinkOutlined },
  { value: 36, label: 'Research Impact', icon: BarChartOutlined },
];

const Impact = () => <LabImpact labName="ARSL" metrics={metrics} />;

export default Impact;
